/**
 * ComfoFeet — US variant labels → UK / AU / EU display by locale & URL.
 * EU sizes from brand chart (US vs EU); AU mirrors UK numbering.
 * Safe to load from theme or inject via A/B tooling (late load supported).
 * Double-load guarded with window.__comfofeetRegionalSizesInit.
 */
(function () {
  'use strict';

  if (window.__comfofeetRegionalSizesInit) {
    return;
  }
  window.__comfofeetRegionalSizesInit = true;

  if (!window.Shopify) {
    window.ComfofeetRegionalSizes = { active: false, reason: 'no-shopify' };
    return;
  }

  function getRegionalSizeMode() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var segments = window.location.pathname.toLowerCase().split('/').filter(Boolean);

    if (lang === 'en-gb' || segments.indexOf('en-gb') !== -1) {
      return 'uk';
    }
    if (lang === 'en-au' || segments.indexOf('en-au') !== -1) {
      return 'au';
    }

    if (segments.indexOf('eu') !== -1 || lang === 'en-eu') {
      return 'eu';
    }

    var mh =
      window.Shopify &&
      window.Shopify.market &&
      window.Shopify.market.handle
        ? String(window.Shopify.market.handle).toLowerCase()
        : '';
    if (
      mh &&
      (mh === 'eu' ||
        mh === 'europe' ||
        mh.indexOf('european') !== -1 ||
        mh === 'de' ||
        mh === 'fr' ||
        mh === 'es' ||
        mh === 'it' ||
        mh === 'nl' ||
        mh === 'pl' ||
        mh === 'at' ||
        mh === 'be' ||
        mh === 'se' ||
        mh === 'dk' ||
        mh === 'fi' ||
        mh === 'ie' ||
        mh === 'pt' ||
        mh === 'cz' ||
        mh === 'sk' ||
        mh === 'hu' ||
        mh === 'ro' ||
        mh === 'ch')
    ) {
      return 'eu';
    }

    var euPrimaryLangs = [
      'de',
      'fr',
      'es',
      'it',
      'nl',
      'pl',
      'pt',
      'sv',
      'da',
      'fi',
      'cs',
      'el',
      'hu',
      'ro',
      'sk',
      'sl',
      'bg',
      'hr',
      'lt',
      'lv',
      'et',
      'mt',
      'ga',
      'lb',
      'no',
      'is',
    ];
    var parts = lang.split('-');
    var primary = parts[0];
    var region = parts[1];
    if (primary === 'en' && region && euPrimaryLangs.indexOf(region) !== -1) {
      return 'eu';
    }
    if (primary !== 'en' && euPrimaryLangs.indexOf(primary) !== -1) {
      return 'eu';
    }

    return null;
  }

  var regionalMode = getRegionalSizeMode();
  if (!regionalMode) {
    window.ComfofeetRegionalSizes = { active: false, reason: 'locale' };
    return;
  }

  var sizePrefix =
    regionalMode === 'au' ? 'AU' : regionalMode === 'eu' ? 'EU' : 'UK';

  window.ComfofeetRegionalSizes = {
    active: true,
    mode: regionalMode,
    prefix: sizePrefix,
    version: '1.1.0',
  };

  var variantMapUK = {
    'US 4': 'UK 3',
    'US 5.5': 'UK 4.5',
    'US 6': 'UK 5',
    'US 6.5': 'UK 5.5',
    'US 7': 'UK 6',
    'US 7.5': 'UK 6.5',
    'US 8': 'UK 7',
    'US 8.5': 'UK 7.5',
    'US 9': 'UK 8',
    'US 9.5': 'UK 8.5',
    'US 10': 'UK 9',
    'US 10.5': 'UK 9.5',
    'US 11': 'UK 10',
    'US 11.5': 'UK 10.5',
    'US 12': 'UK 11',
    'US 12.5': 'UK 11.5',
    'US 13': 'UK 12',
    'US 13.5': 'UK 12.5',
    'US 14': 'UK 13',
    'US 14.5': 'UK 13.5',
    'US 15': 'UK 14',
    'US 15.5': 'UK 14.5',
    'US 16': 'UK 15',
  };

  /* From brand conversion chart (US men's → EU) */
  var variantMapEU = {
    'US 4': 'EU 36',
    'US 5.5': 'EU 37',
    'US 6': 'EU 38',
    'US 6.5': 'EU 40',
    'US 7': 'EU 40',
    'US 7.5': 'EU 41',
    'US 8': 'EU 41',
    'US 8.5': 'EU 42',
    'US 9': 'EU 42',
    'US 9.5': 'EU 43',
    'US 10': 'EU 43',
    'US 10.5': 'EU 44',
    'US 11': 'EU 44',
    'US 11.5': 'EU 45',
    'US 12': 'EU 45',
    'US 12.5': 'EU 46',
    'US 13': 'EU 46',
    'US 13.5': 'EU 47',
    'US 14': 'EU 47',
    'US 14.5': 'EU 48',
    'US 15': 'EU 49',
    'US 15.5': 'EU 49',
    'US 16': 'EU 50',
  };

  var variantMap =
    regionalMode === 'au'
      ? Object.keys(variantMapUK).reduce(function (acc, key) {
          acc[key] = variantMapUK[key].replace(/^UK/, 'AU');
          return acc;
        }, {})
      : regionalMode === 'eu'
        ? variantMapEU
        : variantMapUK;

  function convertUSToUK(sizeText) {
    if (!sizeText) return null;

    sizeText = sizeText.trim();

    if (new RegExp('^' + sizePrefix, 'i').test(sizeText)) {
      return null;
    }

    var womenSplitMatch = sizeText.match(
      /^US\s*Women\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/i
    );
    if (womenSplitMatch) {
      if (regionalMode === 'eu') {
        var ew1 = formatSize(parseFloat(womenSplitMatch[1]) + 31);
        var ew2 = formatSize(parseFloat(womenSplitMatch[2]) + 31);
        return 'EU Women ' + ew1 + ' / ' + ew2;
      }
      var size1w = parseFloat(womenSplitMatch[1]) - 2;
      var size2w = parseFloat(womenSplitMatch[2]) - 2;
      return sizePrefix + ' Women ' + formatSize(size1w) + ' / ' + formatSize(size2w);
    }

    var womenMatch = sizeText.match(/^US\s*Women\s*(\d+(?:\.\d+)?)$/i);
    if (womenMatch) {
      if (regionalMode === 'eu') {
        var ew = formatSize(parseFloat(womenMatch[1]) + 31);
        return 'EU Women ' + ew;
      }
      var usSizeW = parseFloat(womenMatch[1]) - 2;
      return sizePrefix + ' Women ' + formatSize(usSizeW);
    }

    var normalized = normalizeSize(sizeText);
    if (variantMap[normalized]) {
      return variantMap[normalized];
    }

    if (!/(?:UK|AU|EU)/i.test(sizeText)) {
      var plainNumberMatch = sizeText.match(/^(\d+(?:\.\d+)?)$/);
      if (plainNumberMatch) {
        var usKey = 'US ' + plainNumberMatch[1];
        if (variantMap[usKey]) {
          return variantMap[usKey];
        }
      }
    }
    return null;
  }

  function formatSize(num) {
    return num % 1 === 0 ? num : num.toFixed(1);
  }

  function normalizeSize(size) {
    if (!size) return null;

    size = size.trim();

    if (!/^US/i.test(size)) return null;

    var usMatch = size.match(/^US\s*(?:Men\s*)?(\d+(?:\.\d+)?)$/i);
    if (usMatch) {
      return 'US ' + usMatch[1];
    }

    return null;
  }

  function updateVariantSelectors() {
    var selector = [
      'select[name^="options"] option',
      'input[type="radio"][name^="options"] + label',
      '.variant-input-wrapper label',
      '.swatch label',
      '.ig-variant-pills__btn',
    ].join(', ');

    document.querySelectorAll(selector).forEach(function (el) {
      var text = el.textContent && el.textContent.trim();
      var converted = convertUSToUK(text);
      if (converted && el.textContent.trim() !== converted) {
        el.textContent = converted;
        if (el.title && el.title !== converted) el.title = converted;
      }
    });
  }

  function updateSizeLabels() {
    document
      .querySelectorAll(
        '.form__label span[id^="custom-label-"], .sticky-add-to-cart span, .mobile-add-to-cart span, .bottom-cart span, .cart-drawer span[class*="variant"], .cart__item .variant, .cart-item__variant, .cart-line__variant'
      )
      .forEach(function (el) {
        var text = el.textContent && el.textContent.trim();
        var sizeHead = text && text.match(/^Size\s*[-:]\s*(.+)$/i);
        if (sizeHead) {
          var size = sizeHead[1].trim();
          var converted = convertUSToUK(size);
          if (converted) {
            var newText = 'Size - ' + converted;
            if (el.textContent.trim() !== newText) {
              el.textContent = newText;
            }
          }
        }
      });
  }

  function updateFullVariantStrings() {
    document
      .querySelectorAll(
        'select[name="id"] option, .select__select option, .sticky-add-to-cart span, .bottom-cart span, .cart-drawer span, .cart__item span, [class*="cart"] .variant-text, .cart-line__details span, .cart-drawer .product-option, .cart-item__details .product-option'
      )
      .forEach(function (el) {
        var text = el.textContent && el.textContent.trim();
        if (!text) return;

        if (/(?:UK|AU|EU)\s*Women\s*\d+(?:\.\d+)?\s*\/\s*\d+(?:\.\d+)?/i.test(text)) {
          return;
        }

        var convertedOnly = convertUSToUK(text);
        if (convertedOnly && el.textContent.trim() !== convertedOnly) {
          el.textContent = convertedOnly;
          if (el.title && el.title !== convertedOnly) el.title = convertedOnly;
          return;
        }

        var match = text.match(
          /^(.+?)\s*\/\s*(US\s*(?:Men|Women)?\s*\d+(?:\.\d+)?(?:\s*\/\s*\d+(?:\.\d+)?)?|\d+(?:\.\d+)?)$/i
        );
        if (!match) return;

        var color = match[1].trim();
        var size = match[2].trim();

        var converted = convertUSToUK(size);
        if (!converted) return;
        var newText = color + ' / ' + converted;

        if (el.textContent.trim() !== newText) {
          el.textContent = newText;
          if (el.title && el.title !== newText) el.title = newText;
        }
      });
  }

  function fixOptionLabelFormatting() {
    document.querySelectorAll('.product-form__label-container span').forEach(function (span) {
      var text = span.textContent && span.textContent.trim();
      if (!text) return;

      var labelMatch = text.match(/^(Color|Size)\s*[-:]\s*(.+)$/i);
      if (labelMatch) {
        var label = labelMatch[1];
        var value = labelMatch[2].trim();

        var converted = convertUSToUK(value);
        var finalValue = converted || value;

        var newText = label + ' : ' + finalValue;
        if (span.textContent.trim() !== newText) {
          span.textContent = newText;
        }
        return;
      }

      var convertedSimple = convertUSToUK(text);
      if (convertedSimple && span.textContent.trim() !== convertedSimple) {
        span.textContent = convertedSimple;
      }
    });
  }

  function updateVariantNames() {
    updateVariantSelectors();
    updateSizeLabels();
    updateFullVariantStrings();
    fixOptionLabelFormatting();
  }

  var updateTimer;

  function runSmoothUpdate() {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(function () {
      requestAnimationFrame(updateVariantNames);
    }, 30);
  }

  function boot() {
    runSmoothUpdate();
    setTimeout(runSmoothUpdate, 650);
    setTimeout(runSmoothUpdate, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('variant:change', runSmoothUpdate);
  document.addEventListener('cart:updated', runSmoothUpdate);
  document.addEventListener('ajax:cart:updated', runSmoothUpdate);
  document.addEventListener('cart:refresh', runSmoothUpdate);
  document.addEventListener('shopify:section:load', runSmoothUpdate);

  new MutationObserver(runSmoothUpdate).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
